import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Patch ResizeObserver so any synchronous "ResizeObserver loop" exception is
// swallowed. We DON'T wrap the callback in rAF (that would delay layout
// measurement and break libraries like ReactFlow that depend on synchronous
// resize feedback).
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class PatchedRO extends NativeRO {
    constructor(cb) {
      super((entries, obs) => {
        try {
          cb(entries, obs);
        } catch (e) {
          if (!/ResizeObserver loop/i.test(e?.message || "")) throw e;
        }
      });
    }
  };
}

// Belt-and-suspenders: still suppress any stray "ResizeObserver loop" errors
// that might leak through (e.g., from third-party scripts), to keep CRA's
// dev-overlay quiet.
const RO_MSG = /ResizeObserver loop/i;
window.addEventListener(
  "error",
  (e) => {
    if (e?.message && RO_MSG.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  { capture: true },
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    const msg = e?.reason?.message || String(e?.reason || "");
    if (RO_MSG.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  { capture: true },
);
// Also drop noisy ResizeObserver console.error calls.
const origConsoleError = console.error;
console.error = (...args) => {
  if (args.length && typeof args[0] === "string" && RO_MSG.test(args[0])) return;
  origConsoleError.apply(console, args);
};
// Surgical fallback: if CRA's dev-overlay still slips in, immediately remove it.
if (typeof MutationObserver !== "undefined") {
  const ROobs = new MutationObserver(() => {
    document
      .querySelectorAll("iframe#webpack-dev-server-client-overlay")
      .forEach((f) => f.remove());
  });
  ROobs.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
